import { useMediaQuery } from "@material-ui/core";
import React from "react";
import {
	ArrayField,
	BooleanField,
	ChipField,
	DateField,
	EditButton,
	List as RaList,
	SingleFieldList,
	TextField,
} from "react-admin";
import ResponsiveList from "../components/lists/ResponsiveList";
import { useListStyles } from "../components/lists/useStyles";
import perPage from "../utils/per-page";
import Filters from "./Filters";

const List = (props) => {
	const isBig = useMediaQuery((theme) => theme.breakpoints.up("xl"));
	const classes = useListStyles();
	return (
		<RaList
			{...props}
			classes={classes}
			filters={<Filters />}
			perPage={perPage(50, 25)}
		>
			<ResponsiveList
				mobileHeader={
					<React.Fragment>
						<TextField
							source="name"
							variant="h6"
							style={{ fontWeight: "bold" }}
						/>
						<EditButton />
					</React.Fragment>
				}
				mobileBody={
					<React.Fragment>
						<TextField source="type" />
						<TextField source="code" />
						<TextField source="name" />
						<TextField source="value_type" />
						<BooleanField source="show_deal" />
						<ArrayField source="roles">
							<SingleFieldList>
								<TextField source="name" />
							</SingleFieldList>
						</ArrayField>
					</React.Fragment>
				}
			>
				<TextField source="id" label="ID" style={{ fontWeight: "bold" }} />
				{isBig && <TextField source="order" />}
				<TextField source="type" />
				<ChipField source="code" style={{ marginLeft: 0 }} />
				<TextField source="name" />
				<TextField source="value_type" />

				<ArrayField source="roles">
					<SingleFieldList>
						<ChipField source="name" style={{ marginLeft: 0 }} />
					</SingleFieldList>
				</ArrayField>
				<BooleanField source="show_deal" />
				{isBig && <DateField source="modified" showTime />}
				<EditButton />
			</ResponsiveList>
		</RaList>
	);
};
export default List;
